import axios, { AxiosRequestConfig } from "axios";

export interface StoreFrontApiConfig {
  basePath: string;
  baseOptions?: AxiosRequestConfig;
}

export interface generateUserGuestInterface {
  storeId: number;
}

export interface GenerateUserGuestResponse {
  access_token: string;
  token_type: string;
  expires_in: number;
  refresh_token: null;
  id_token: null;
  user_details: {
    user_id: string;
    user_type: string;
    store_id: string;
  };
}

class StoreFrontApi {
  private basePath: string;
  private baseOptions?: AxiosRequestConfig;

  constructor(config: StoreFrontApiConfig) {
    this.basePath = config?.basePath ?? "";
    this.baseOptions = config?.baseOptions;
  }

  async generateUserGuest<T>(
    params: generateUserGuestInterface,
  ): Promise<T | any> {
    const options: AxiosRequestConfig = {
      ...this.baseOptions,
      method: "POST",
    };
    const url = `${this.basePath}/api/storefront/1/stores/${params?.storeId}/users/guests`;

    try {
      const response = await axios(url, options);
      return await response.data;
    } catch (error) {
      throw new Error("Failed to fetch cart count.");
    }
  }
}

export default StoreFrontApi;
